import React, { FC, memo, useCallback } from 'react';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';

import { PathName } from 'appConstants';

import { Button } from 'components';

import styles from './styles.module.scss';

interface ISignInUsButtons {
  onBurgerChange?: () => void;
}

export const SignInUsButtons:FC<ISignInUsButtons> = memo(({ onBurgerChange }) => {
  const navigate = useNavigate();
  const referralFromURL = window?.location?.search;

  const onClickSignIn = useCallback(() => {
    if (onBurgerChange) {
      onBurgerChange();
    }
    navigate(`${PathName.SignIn}/${referralFromURL}`);
  }, [navigate, onBurgerChange, referralFromURL]);

  const onClickRegistration = useCallback(() => {
    if (onBurgerChange) {
      onBurgerChange();
    }
    navigate(`${PathName.Registration}/${referralFromURL}`);
  }, [navigate, onBurgerChange, referralFromURL]);

  const { t } = useTranslation('main');
  return (
    <div className={styles.buttons}>
      <Button
        onClick={onClickSignIn}
        isBgTransparent
        color="blueTransparent"
      >
        {t('Entrance_')}
      </Button>
      <Button
        onClick={onClickRegistration}
        color="blue"
      >
        {t('Register_')}
      </Button>
    </div>
  );
});
